import React from 'react'
import downArrow from '../assets/images/down_arrow.png'

const ScrollMouseAnimation = ({ isVisible }) => {
  return (
    <div>
      <a href="#">
        {/* <div
          id="mouse-scroll"
          style={{
            opacity: isVisible ? 1 : 0,
            transition: "opacity 0.4s ease-in-out",
            pointerEvents: "none",
          }}
        >
          <div className="mouse">
            <div className="mouse-in"></div>
          </div>
          <div className="d-flex flex-column align-items-center justify-content-center">
            <span className="down-arrow-1"></span>
            <span className="down-arrow-2"></span>
            <span className="down-arrow-3"></span>
          </div>
        </div> */}
        <div
          id="mouse-scroll"
          style={{
            opacity: isVisible ? 1 : 0,
            transition: "opacity 0.4s ease-in-out",
            pointerEvents: "none",
          }}
        >
          {/* <div className="mouseScrollContainer">
            <p >
              Scroll to see key <br /> country stories
            </p>
            <img className="downArrowImage" src={downArrow} alt="downArrow" />
          </div> */}
        </div>
      </a>
    </div>
  );
};

export default ScrollMouseAnimation